<template>
    <main-table-layout
        sub-menu-selector="adminpanel"
    >
        <div slot="buttonsRight"/>
        <content-filter
                slot="filter"
                @filter="filtering"
                :id="'roleList'"
                store-name="Role"
        />

            <view-switcher
                slot="mainContentButtons"
                :id="'mainContent'"
                :table="true"
                :thumbnails="true"
            />
        <pagination
                slot="mainContentButtons"
                :limit="paginationLimit"
                :total="$store.getters.getRoleListOptions(listName, 'pagination_items')"
                :id="'roletablepage'"
                @setActive="loadPaginatedData"
                ref="pagination"
        />
        <Button
            permission="createRole"
                type="action-button" slot="mainContentButtons" link="/admin/roles/add" icon="plus">
                {{ $t('createNewType', {type: $t('role')}) }}
        </Button>
<Button
           slot="mainContent"
           @click="loadPaginatedData(0); $refs.pagination.setActive(0)"
           type="reload"
           icon="rotate-right"
           class="icon-button"
       />
            <table-widget
                    v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'table'"
                    slot="mainContent"
                    :id="'rolesDefaultTable'"
                    :nav-by-clicking-row="true"
                    :deletable="true"
                    @deleteRow="deleteRow"
                    :show-tags="false"
                    :show-organization="false"
                    :fields="tableFields"
                    :data="$store.getters.getRolesByListName(listName)"
                    :title-as-links="true"
                    :key="forceReRenderKey"
                    edit-permission="editRole"
                    delete-permission="deleteRole"
                    resource="Role"
                     :loading="loading"
                    @sort="sort"
            />
            <thumbnails
                    v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'thumbnails'"
                    slot="mainContent"
                    :id="'rolesDefaultThumbnails'"
                    :deletable="true"
                    @deleteRow="deleteRow"
                    :nav-by-clicking-row="true"
                    edit-permission="editRole"
                    delete-permission="deleteRole"
                    :fields="thumbnailFields"
                    :data="$store.getters.getRolesByListName(listName)"
                    :title-as-links="true"
                    :key="forceReRenderKey"
                    resource="Role"
                    :loading="loading"
                    @sort="sort"
            />
    </main-table-layout>
</template>

<script>
    import Button from "../components/forms/Button";
    import ContentFilter from "../components/widgets/filter/ContentFilter";
    import MainTableLayout from "../layouts/MainTableLayout";
    import ViewSwitcher from "../components/widgets/ViewSwitcher";
    import Thumbnails from "../components/widgets/ThumbnailView";
    import Pagination from "../components/Pagination";
    import TableWidget from "@/components/widgets/TableWidget";
    import { mapState } from 'vuex';

    export default {
        name: "Roles",
        components: {
            Button,
            TableWidget,
            ContentFilter,
            MainTableLayout,
            ViewSwitcher,
            Thumbnails,
            Pagination,
        },
        data() {
            return {
                loading: true,
                listName: 'RoleList',
                offset: 0,
                sorting: '-updatedAt',
                filter: {},
                paginationLimit: 15,
                queryRelevantComponents: 2, //pagination and filter
                queryRelevantInits: 0,
                viewId: 'mainContent',
                forceReRenderKey: 0,
                tableFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                    {
                      name: 'DisplayName',
                      id: 'displayName',
                      type: 'string',
                      sortable: true
                    },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
                thumbnailFields: [
                    {
                        name: '',
                        id:'',
                        type: 'image',
                    },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                  {
                    name: 'DisplayName',
                    id: 'displayName',
                    type: 'string',
                    sortable: true
                  },
                    {
                        name: 'Tags',
                        id:'tags',
                        type: 'tags',
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
            };
        },
        computed: mapState({pages: state => state.page.pages,}),
        watch: {
            queryRelevantInits: function(newval) {
                if(newval === this.queryRelevantComponents) {
                    this.loadRoles();
                }
            }
        },
        methods: {
            loadRoles(initial = false) {
              this.loading = true;
              let args = {
                listName: this.listName
              };
              const paginationAddOn = {
                limit: {
                  default: this.paginationLimit
                },
                offset: {
                  default: this.offset,
                },
                paging: {
                  default: true
                },
                sort: {
                  [this.listName]: this.sorting,
                }
              }
              args.add = this.filter.add ? {...paginationAddOn, ...this.filter.add } : paginationAddOn;
              if(this.filter.remove) {args.remove = this.filter.remove}
              if(!initial || this.queryRelevantInits >= this.queryRelevantComponents) {
                this.$store.dispatch('loadRoles', args).then(data => {
                  this.list = data;
                  this.loading = false;
                });
              } else {
                this.$store.dispatch('registerRoleQueryParams', {listName: this.listName, params: args});
              }
            },

            deleteRow: function(id) {
                this.$store.dispatch('deleteRole', {
                    args: [id]
                });
            },
            filtering(val, initial) {
              this.queryRelevantInits++;
              this.filter = val;
              this.loadRoles(initial);
            },
            loadPaginatedData(offset, initial) {
              this.queryRelevantInits++;
              this.offset = offset;
              this.loadRoles(initial);
            },
            sort(args) {
              const {fieldname, direction} = args;
              const sortString = direction + fieldname;
              if(this.sorting !== sortString) {
                this.sorting = sortString;
              }
              this.loadRoles(false);
            }
        }
    }
</script>